module.exports = __webpack_public_path__ + "img/3939784_0100.20e0c2c5.jpg";